import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import { Box } from "@mui/material";

type Props = {
  closeOverlay: () => void;
  children?: React.ReactNode;
};

const Overlay = ({ closeOverlay, children }: Props) => {
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.95)",
          zIndex: 99999,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CloseIcon
          sx={{
            position: "absolute",
            top: "20px",
            right: "20px",
            width: "45px",
            height: "auto",
            cursor: "pointer",
            fill: "white",
            zIndex: 99999,
            justifySelf: "flex-end",
            alignSelf: "flex-end",
          }}
          onClick={() => closeOverlay()}
        />
        {children}
      </Box>
    </>
  );
};

export default Overlay;
